/* eslint jsx-a11y/href-no-hash: "off" */
import React from "react";
import { setMatchmakingValue } from "../redux-actions/battle-actions.js";

class MenuHeaderInviteLink extends React.Component {
  handleClick(e) {
    e.preventDefault();
    setMatchmakingValue({
      isLobbyInviteModalOpen: true
    });
  }

  render() {
    return (
      <a
        className="menu-header__link"
        style={this.props.customStyle}
        href="#"
        onClick={this.handleClick.bind(this)}
      >
        {this.props.text}
      </a>
    );
  }
}

MenuHeaderInviteLink.defaultProps = {
  text: "Invite",
  customStyle: {}
};

export default MenuHeaderInviteLink;



// WEBPACK FOOTER //
// ./src/b5-home/MenuHeaderInviteLink.js